<template>
  <div class='wrap'>
   <my-header></my-header>
    <div class="main">
        <Fun-left></Fun-left>
        <Fun-right></Fun-right>
    </div>
    <messageInfo></messageInfo>
  </div>
</template>

<script>
import myHeader from './header/index'
import FunLeft from './fun_left/index'
import FunRight from './fun_right/index'
import messageInfo from './messageInfo/checkMessage'
export default {
  components: {
    myHeader,
    FunLeft,
    FunRight,
    messageInfo
  }
}
</script>

<style>
html,body{
  width: 100%;
  height:100%;
  overflow: hidden;
}
.wrap{
  width: 960px;
	height: 100vh;
  overflow: hidden;
}
.main{
    width: 960px;
    height: calc(100vh - 30px);
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Medium;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/index.vue